import { jwtDecode } from "jwt-decode";

export function getUserFromToken() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function isAdmin() {
  const user = getUserFromToken();
  return user && user.role === "admin";
}

export function logout() {
  localStorage.removeItem("token");
  window.location.href = "/";
} 